import React from 'react';
import { useUser } from '../providers/UserProvider';

const WelcomeBanner: React.FC<{ forcedTitle?: string }> = ({ forcedTitle }) => {
    const { user, isLoading } = useUser();

    let welcomeName = 'there';
    if (user && user.name) {
        welcomeName = user.name;
    }

    return (
        <div className="absolute top-8 left-8 z-10">
            <h2 className="text-2xl font-bold text-gray-800">
                {isLoading ? 'Loading...' : forcedTitle || `Welcome back, ${welcomeName}`}
            </h2>
        </div>
    );
};

export default WelcomeBanner;
